import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Block } from '@core/models/block/block.model';
import { ButtonHandlerService } from '@core/services/button-handler.service';
import { filter, tap } from 'rxjs/operators';
import { BlockActionType } from '@core/enums';
import { SubSink } from '@core/utils/subsink';
import { FormService } from '@modules/creator/components/special-block/forms/services/form.service';
import { Router } from '@angular/router';
import { ApiGlobalSearchService } from '@core/services/api/api-global-search.service';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-global-search-input',
    template: `
  <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div app-block-container [children]="block.children"></div>
  </form>
  `,
    styles: [
        `
      :host
      ::ng-deep
      .mat-mdc-form-field-appearance-outline
      .mat-mdc-form-field-wrapper {
        margin: 0 !important;
        padding-bottom: 0 !important;
      }

      :host {
        all: inherit;
      }
    `,
    ],
    standalone: false
})

export class GlobalSearchInputComponent implements OnInit, OnDestroy {
  @Input() block: Block;
  formGroup = this._fs.formGroup;
  searchUrl: string;
  private subSink = new SubSink();

  constructor(
    private buttonHandlerService: ButtonHandlerService,
    private _fs: FormService,
    private router: Router,
    private apiGlobalSearchService: ApiGlobalSearchService,
    @Inject(DOCUMENT) private document: Document
  ) {
  }


  ngOnInit() {
   
    this._fs.resetValue('search');
    this.formGroup.patchValue({ extended_search: false });
    
    this.subSink.sink = this.apiGlobalSearchService.getGlobalSearchPageUrl().subscribe(({url}) => {
      this.searchUrl = url;
    });

    this.subSink.sink =
      this.buttonHandlerService.click$
        .pipe(
          filter(({actionType}) => (
            actionType === BlockActionType.SUBMIT
            && this._fs.formGroup.valid)),
          tap(() => {
            const formValue = this.formGroup.getRawValue();
            setTimeout(() => {
              this.router.navigate([this.searchUrl], {queryParams: {search: formValue.search, extendedSearch: formValue.extended_search}});
            });
          }),
        ).subscribe();

    // search Subscription
    this._fs.keyboardEvent
    .pipe(
      filter((e: KeyboardEvent) => ['Enter', 'NumpadEnter'].includes(e.code)),
      filter((e: KeyboardEvent) => {
        const el = e.target as HTMLElement | null;
        return !el?.closest('mat-checkbox,[role="checkbox"]');
      }),
  
      filter(_ => this._fs.formGroup.valid),
  
      tap(_ => {
        const formValue = this.formGroup.getRawValue();
        this.document.body.style.removeProperty('overflow');
        this.router.navigate(
          [this.searchUrl],
          { queryParams: { search: formValue.search, extendedSearch: formValue.extended_search } }
        );
      })
    )
    .subscribe();
  
  }

  onSubmit() {
    if (this.formGroup.valid) {
      this.navigateToSearchPage();
    }
  }

  private navigateToSearchPage() {
    const formValue = this.formGroup.getRawValue();
    this.document.body.style.removeProperty('overflow');
    this.router.navigate([this.searchUrl], { queryParams: { search: formValue.search } });
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }
}
